export var createCrossTabNotifier = function (window) {
    var ns = 'ans-cross-tab-beacon';
    var listeners = {};
    var eventSet = false;
    var onEvent = function (data) {
        var keyListeners = (listeners[data.key] || []);
        keyListeners.forEach(function (cb) {
            try {
                cb(data.msg);
            }
            catch (e) {
                console.warn('error on tabs notifier listener for ', data.key);
            }
        });
    };
    var parseValue = function (val) {
        try {
            if (val) {
                return JSON.parse(val);
            }
            else {
                return undefined;
            }
        }
        catch (e) {
            return undefined;
        }
    };
    var init = function () {
        window.addEventListener('storage', function (e) {
            if (e.key === ns && e.newValue) {
                var parsedValue = parseValue(e.newValue);
                if (parsedValue) {
                    onEvent(parsedValue);
                }
            }
        });
        eventSet = true;
    };
    return {
        emit: function (key, msg) {
            var item = {
                key: key,
                msg: msg
            };
            try {
                var strItem = JSON.stringify(item);
                localStorage.setItem(ns, strItem);
            }
            catch (e) {
                console.warn('error emitting tabs notifier');
            }
        },
        listen: function (key, cb) {
            if (!eventSet) {
                init();
            }
            if (!listeners[key]) {
                listeners[key] = [];
            }
            listeners[key].push(cb);
            return function () {
                listeners[key] = listeners[key].filter(function (iCb) { return iCb !== cb; });
            };
        },
        getLast: function (key) {
            try {
                var storedValue = localStorage.getItem(ns);
                if (storedValue) {
                    var parsedValue = parseValue(storedValue);
                    if (parsedValue && parsedValue.key === key) {
                        return parsedValue.msg;
                    }
                }
            }
            catch (e) {
                console.warn('error getting last tab notification');
            }
        }
    };
};
//# sourceMappingURL=index.js.map